import { DateTime } from "luxon";

export const getLabelTextFromISO = (eventISO: string) => {
  const dateTime = DateTime.fromISO(eventISO);

  let datePrefix = "";
  let dateFormat = "EEE MMM d, h:mm"; // "Wed Jul 14, 3:30 PM"
  if (dateTime.hasSame(DateTime.now(), "day")) {
    datePrefix = "Today";
    dateFormat = "h:mm"; // "Today 3:30 PM"
  } else if (dateTime.hasSame(DateTime.now().plus({ days: 1 }), "day")) {
    datePrefix = "Tomorrow";
    dateFormat = "h:mm"; // "Tomorrow 3:30 PM"
  } else if (dateTime.hasSame(DateTime.now(), "week")) {
    dateFormat = "EEE h:mm"; // "Wed 3:30 PM"
  }

  return `${datePrefix} ${dateTime.toFormat(dateFormat)}${dateTime.toFormat("a").toLowerCase()}`;
};
